/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".import-row-msg{white-space:normal;word-wrap:break-spaces}.manual-hyphens{white-space:normal;-webkit-hyphens:manual;-ms-hyphens:manual;hyphens:manual}"];
export { styles as styles };
